import { LookbookAPIResponse } from '@moment/net/softbox-types.ts';
import { resolvedLanguage } from '@/i18n.ts';
import {
  API_URL,
  DEFAULT_CKEY,
  getInitializedMomentFetcher,
} from '../fetch-contstants.ts';
import { IDailyLookBook } from '@pages/Root/services/api/lookBook/lookbook-model-definitions.ts';
import { RoutePrefetchQueryOptions } from '@moment/routes/types.ts';
import { fetchScheduleItems } from '@moment/net/classic-fotoscapes/fetch-interests-page-data.ts';
import {
  INTEREST_SCHEDULE,
  POPULAR_SCHEDULE,
} from '@pages/Root/pages/HomeRoot/constants.ts';

export type StoryRouteParams = { uid: string; title?: string };

export interface StoryRouteResponse {
  lookbook: LookbookAPIResponse;
  popularInterest: IDailyLookBook[];
  travelInterest: IDailyLookBook[];
}

const fetchLookbookById = async (
  lookbookId: string | undefined,
  language: string
) => {
  const momentFetcher = await getInitializedMomentFetcher();
  const url = `${API_URL}/wp/v1/lookbook/${lookbookId}?ckey=${DEFAULT_CKEY}&mp_lang=${language}`;
  const rawResponse = await momentFetcher.fetch(url);
  return (await rawResponse.json()) as LookbookAPIResponse;
};

export const generateStoryFetchLookbookQuery = (
  options?: RoutePrefetchQueryOptions & StoryRouteResponse
) => {
  return async (): Promise<StoryRouteResponse> => {
    const logger = options ? options.logger : undefined;
    const lookbookId = options ? options.uid : undefined;
    const l = options ? options.lang : undefined;
    const lang = l || resolvedLanguage('en');
    const lookbook = await fetchLookbookById(lookbookId, lang);
    const popularInterest = await fetchScheduleItems(lang, POPULAR_SCHEDULE);
    const travelInterest = await fetchScheduleItems(
      lang,
      INTEREST_SCHEDULE.NZf7cr
    );
    return {
      lookbook,
      popularInterest,
      travelInterest,
    };
  };
};
